import { t, intlLocale } from '@procumi/shared';
import type { ReactNode } from 'react';
import { useCountUp } from '../ControlPanel';

/**
 * Piesele mici comune panoului firmei: iconițele (caroiaj de 16, doar contur),
 * cifra care urcă, eticheta de tendință și capul de secțiune.
 */

export const PATHS = {
  search: 'M7.2 12.4a5.2 5.2 0 1 0 0-10.4 5.2 5.2 0 0 0 0 10.4zM14 14l-3.1-3.1',
  plus: 'M8 3v10M3 8h10',
  rfq: 'M9.2 1.8H4.8A1.6 1.6 0 0 0 3.2 3.4v9.2a1.6 1.6 0 0 0 1.6 1.6h6.4a1.6 1.6 0 0 0 1.6-1.6V5.4L9.2 1.8ZM9 2v3.2h3.6M5.8 8.6h4.4M5.8 11h2.8',
  inbox:
    'M2 9.5 3.6 3.8A1.2 1.2 0 0 1 4.8 3h6.4a1.2 1.2 0 0 1 1.2.8L14 9.5V12a1.2 1.2 0 0 1-1.2 1.2H3.2A1.2 1.2 0 0 1 2 12zM2 9.5h3.2l.8 1.6h4l.8-1.6H14',
  people:
    'M6 7a2.3 2.3 0 1 0 0-4.6A2.3 2.3 0 0 0 6 7zM1.8 13.5a4.2 4.2 0 0 1 8.4 0M11 7.2a2 2 0 1 0-.6-3.9M12.2 13.5h2a3.7 3.7 0 0 0-2.6-3.6',
  coins:
    'M6 6.5c2.5 0 4.5-.9 4.5-2S8.5 2.5 6 2.5 1.5 3.4 1.5 4.5s2 2 4.5 2zM1.5 4.5v3c0 1.1 2 2 4.5 2M1.5 7.5v3c0 1.1 2 2 4.5 2M10 9.5c2.5 0 4.5-.9 4.5-2s-2-2-4.5-2-4.5.9-4.5 2 2 2 4.5 2zM5.5 7.5v4c0 1.1 2 2 4.5 2s4.5-.9 4.5-2v-4',
  trend: 'M1.5 11.5 6 7l3 3 5.5-5.5M10.5 4.5h4v4',
  box: 'M8 1.8 13.5 4.6v6.8L8 14.2 2.5 11.4V4.6zM2.5 4.6 8 7.4l5.5-2.8M8 7.4v6.8',
  truck:
    'M1.5 4h8v7h-8zM9.5 6.5h3l2 2.5v2h-5M4.5 13a1.3 1.3 0 1 0 0-2.6 1.3 1.3 0 0 0 0 2.6zM11.5 13a1.3 1.3 0 1 0 0-2.6 1.3 1.3 0 0 0 0 2.6z',
  upload: 'M8 10.5v-8M4.5 6 8 2.5 11.5 6M2.5 10.5v2a1 1 0 0 0 1 1h9a1 1 0 0 0 1-1v-2',
  compare: 'M2 3h12v10H2zM2 6.5h12M6.5 6.5V13M10.5 6.5V13',
  calendar: 'M2.5 3.5h11v10h-11zM2.5 6.5h11M5.5 2v3M10.5 2v3',
  chevron: 'm6 4 4 4-4 4',
  down: 'm4 6 4 4 4-4',
  arrow: 'M3 8h10M9 4l4 4-4 4',
  site: 'M2 14V6.5l4-2.5v10M6 14V2.5l8 3V14M1 14h14M8.5 7h1M11.5 7h1M8.5 9.5h1M11.5 9.5h1',
  check: 'm3.5 8.5 3 3 6-7',
  clock: 'M8 14.2A6.2 6.2 0 1 0 8 1.8a6.2 6.2 0 0 0 0 12.4zM8 4.6V8l2.4 1.6',
  x: 'M4.5 4.5l7 7M11.5 4.5l-7 7',
  send: 'M14 2 7 9M14 2l-4.5 12L7 9 2 6.5z',
  star: 'M8 1.8l1.9 3.9 4.3.6-3.1 3 .7 4.3L8 11.6l-3.8 2 .7-4.3-3.1-3 4.3-.6z',
  chat: 'M2.5 3.5h11v7.5H7l-3 2.5V11H2.5z',
  alert: 'M8 2 14.5 13.5h-13zM8 6.5v3M8 11.6v.1',
  pie: 'M8 1.8v6.2h6.2A6.2 6.2 0 1 1 8 1.8zM10 1.8a4.6 4.6 0 0 1 4.2 4.2H10z',
  tag: 'M2 2h5.5l6.5 6.5-5.5 5.5L2 7.5zM5 5h.1',
  help: 'M8 14.2A6.2 6.2 0 1 0 8 1.8a6.2 6.2 0 0 0 0 12.4zM6.2 6.2a1.9 1.9 0 1 1 2.6 1.8c-.5.2-.8.6-.8 1.1v.4M8 11.4v.1',
  mail: 'M2 3.5h12v9H2zM2 4l6 4.5L14 4',
  clipboard: 'M5.5 2.5h5v2h-5zM5.5 3.5h-2v10.5h9V3.5h-2M5.5 8h5M5.5 10.5h3',
};

export function I({ d, size = 16 }: { d: keyof typeof PATHS; size?: number }) {
  return (
    <svg width={size} height={size} viewBox="0 0 16 16" aria-hidden="true" className="di">
      <path
        d={PATHS[d]}
        fill="none"
        stroke="currentColor"
        strokeWidth="1.4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

/** Cifra care urcă la încărcare și se mută lin la schimbarea perioadei. */
export function Num({ value, format }: { value: number; format: (n: number) => string }) {
  const v = useCountUp(value, 700);
  return <>{format(Math.round(v))}</>;
}

/** ▲ 12% / ▼ 8% față de perioada de dinainte; `good` spune dacă creșterea e de bine. */
export function Trend({ pct, good = 'up' }: { pct: number | null; good?: 'up' | 'down' | 'none' }) {
  if (pct == null) return <span className="dt dt-0">{t('fără comparație')}</span>;
  if (pct === 0) return <span className="dt dt-0">{t('la fel')}</span>;
  const up = pct > 0;
  const tone = good === 'none' ? 'n' : (up && good === 'up') || (!up && good === 'down') ? 'g' : 'b';
  return (
    <span className={`dt dt-${tone}`}>
      {up ? '▲' : '▼'} {Math.abs(pct)}%
    </span>
  );
}

export type Tone = 'blue' | 'night' | 'green' | 'amber' | 'red' | 'teal' | 'slate' | 'gray';

/** Capul unui card: plăcuța cu iconiță, titlul, de unde vin datele și acțiunea din dreapta. */
export function CardHead({
  icon,
  tone,
  title,
  sub,
  action,
  id,
}: {
  icon: keyof typeof PATHS;
  tone: Tone;
  title: string;
  sub?: ReactNode;
  action?: ReactNode;
  id?: string;
}) {
  return (
    <header className="db-h">
      <span className={`db-ico ${tone}`}>
        <I d={icon} size={16} />
      </span>
      <div className="db-h-t">
        <h2 id={id}>{title}</h2>
        {sub ? <p>{sub}</p> : null}
      </div>
      {action ? <div className="db-h-a">{action}</div> : null}
    </header>
  );
}

/** Un card al panoului: capul și conținutul. */
export function Section({
  icon,
  tone,
  title,
  sub,
  action,
  className,
  id,
  children,
}: {
  icon: keyof typeof PATHS;
  tone: Tone;
  title: string;
  sub?: ReactNode;
  action?: ReactNode;
  className?: string;
  id?: string;
  children: ReactNode;
}) {
  return (
    <section className={`db-card${className ? ` ${className}` : ''}`} id={id}>
      <CardHead icon={icon} tone={tone} title={title} sub={sub} action={action} />
      {children}
    </section>
  );
}

const ro = new Intl.NumberFormat(intlLocale(), { maximumFractionDigits: 0 });
/** „180.619 lei” */
export const money = (n: number) => t('{0} lei', ro.format(Math.round(n)));
/** „180,6 mii lei” pe axe și în locuri înguste */
export const shortMoney = (n: number) =>
  n >= 1_000_000
    ? t('{0} mil.', (n / 1_000_000).toLocaleString(intlLocale(), { maximumFractionDigits: 1 }))
    : n >= 1000
      ? t('{0} mii', (n / 1000).toLocaleString(intlLocale(), { maximumFractionDigits: 1 }))
      : ro.format(Math.round(n));
export const pct = (x: number) => `${Math.round(x * 100)}%`;
